


















































import { ValidationTool } from '@/util';
import Vue from 'vue';
import {
  Component, Prop, Watch,
} from 'vue-property-decorator';

@Component
export default class EditLogicDialog extends Vue {
  @Prop()
  logic!:string;

  @Prop()
  autoQualifyCycles!:number;

  @Prop({ default: false })
  isEditable!: boolean;

  workingLogic:string = '';

  workingAutoQualifyCycles:number = 0;

  dialog:boolean = false;

  isFormValid:boolean = true;

  requiredAndPositiveRule:Array<any> = [ValidationTool.requiredAndPositiveRuleFunction];

  @Watch('dialog')
  initialize() {
    if (this.dialog) {
      this.workingLogic = this.logic;
      this.workingAutoQualifyCycles = this.autoQualifyCycles;
    }
  }

  cancel() {
    const form: any = this.$refs.form;
    form.reset();
    this.dialog = false;
  }

  save() {
    this.$emit('save', this.workingLogic, this.workingAutoQualifyCycles);
    this.dialog = false;
  }
}
